export default {
    picturePosition: {
        banner: 1
    },
    productType: {
        common: 1,
        fragment: 2,
        container: 3
    },
    productState: {
        waiting: 9,
        normal: 10,
        sellout: 11,
        offline: 12
    },
    orderState: {
        waiting: 1,
        complete: 2,
        cancel: 3
    }
}